import { Title } from '@/components/atoms/Title/Title';

import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';
import {
  SearchButtonFromContext,
  SearchFieldFromContext,
  CareTypePickerFromContext,
} from './context';

interface SearchProps {
  title?: string;
  description?: string;
  text?: string;
  initialSearchTerm?: string;
}
export const CareProviderSearch = ({
  title = 'Find adult care in your area',
  description = 'Search for care homes or care-at-home agencies in your area.',
  text = 'Search',
  initialSearchTerm,
}: SearchProps) => {
  return (
    <Stack sx={{ gap: sp[24], typography: 'bodyLg' }}>
      <Title headingType='h1' isNoMargin>
        {title}
      </Title>
      {description}
      <CareTypePickerFromContext />
      <Stack direction='row' sx={{ gap: sp[24] }}>
        <SearchFieldFromContext initialSearchTerm={initialSearchTerm} />
        <SearchButtonFromContext
          text={text}
          initialSearchTerm={initialSearchTerm}
        />
      </Stack>
    </Stack>
  );
};

export default CareProviderSearch;
